import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./assets/css/app.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import WorkExperience from "./pages/WorkExperience";
import CaseStudies from "./pages/CaseStudies";
import Blog from "./pages/Blog";
// import CustomCursor from "./components/CustomCursor";
import AnimatedBackground from "./components/AnimatedBackground";

function App() {
  return (
    <Router>
      <div className="app">
        {/* <CustomCursor /> */}
        {/* <AnimatedBackground /> */}
        <Header />
        <main className="app__main">
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/work-experience" element={<WorkExperience />} />
            <Route path="/case-studies" element={<CaseStudies />} /> */}
            {/* <Route path="/blog" element={<Blog />} /> */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
